module.exports = __webpack_public_path__ + "img/erp-logos_0016_sage300.8232f087.jpg";